import React from 'react';
import PropTypes from 'prop-types';
import { Section, Container, Typography } from 'components/base';
import { BioSections, CloudinaryPicture, HtmlContent } from 'components/rich';

import { Head, Layout } from '../../components/layout';

export const CONTENT_PAGES = {
  '/privacy': 'privacy',
  '/terms': 'termsofuse',
};

const ContentPage = props => {
  return (
    <React.Fragment key={props.contentId}>
      <Head title={props.pageTitle} description={props.pageDescription} />

      <Layout>
        <Section>
          <Container className="mw-800">
            {props.pageCaption && <Typography.H1>{props.pageCaption}</Typography.H1>}
            {props.imageKey && (
              <CloudinaryPicture imageKey={props.imageKey} className="mt-2 mb-2 d-block mw-100" />
            )}
            <HtmlContent html={props.body} />
            <BioSections bio={props.bio} />
          </Container>
        </Section>
      </Layout>
    </React.Fragment>
  );
};

ContentPage.getInitialProps = async () => {
  throw new Error('Cannot access this page directly. See /[...params] page');
};

ContentPage.propTypes = {
  contentId: PropTypes.string,
  imageKey: PropTypes.string,
  pageTitle: PropTypes.string,
  pageDescription: PropTypes.string,
  pageCaption: PropTypes.string,
  body: PropTypes.string,
  bio: PropTypes.array,
};

export default ContentPage;
